<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Picture In Picture" class="d-icon d-icon--picture-in-picture" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M1 3a1.5 1.5 0 0 1 1.5-1.5H8A1.5 1.5 0 0 1 9.5 3v1a.5.5 0 1 1-1 0V3a.5.5 0 0 0-.5-.5H2.5A.5.5 0 0 0 2 3v3a.5.5 0 0 0 .5.5h1a.5.5 0 1 1 0 1h-1A1.5 1.5 0 0 1 1 6V3Zm4 4a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 11 7v2a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 5 9V7Zm1.5-.5A.5.5 0 0 0 6 7v2a.5.5 0 0 0 .5.5h3A.5.5 0 0 0 10 9V7a.5.5 0 0 0-.5-.5h-3Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconPictureInPicture',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
